import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown } from '@wix/design-system';
import { FiltersMap } from '@wix/bex-core';
import { MultiLevelSortingState, SortableColumn } from '../../state';

export interface MultiLevelSortingColumnSelectProps<T, F extends FiltersMap> {
  sortableColumn: SortableColumn;
  state: MultiLevelSortingState<T, F>;
  index: number;
}

export function _MultiLevelSortingColumnSelect<T, F extends FiltersMap>(
  props: MultiLevelSortingColumnSelectProps<T, F>,
) {
  const { sortableColumn, state } = props;
  const ref = React.useRef<HTMLInputElement | null>();

  const options = state.getAvailableOptions(sortableColumn.columnId);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (!ref.current) {
        return;
      }

      // focus the last added column
      if (sortableColumn.columnId === state.lastManuallyAddedColumnId) {
        state.lastManuallyAddedColumnId = null;
        ref.current.focus();
      }
    });
  }, []);

  return (
    <Dropdown
      inputRef={(node) => {
        if (ref) {
          ref.current = node;
        }
      }}
      dataHook="multi-level-sorting-select-column"
      onSelect={({ id }) => {
        state.replaceSort(sortableColumn.columnId, id as string);
      }}
      popoverProps={{
        appendTo: 'window',
      }}
      options={options}
      selectedId={sortableColumn.columnId}
      size="small"
    />
  );
}

export const MultiLevelSortingColumnSelect = observer(
  _MultiLevelSortingColumnSelect,
);
